import React from "react";
import "./badge.css";

const Badge = ({ item = { title: "Approved", type: "success" } }) => {
	const mapStatusToStyle = {
		warning: "warn",
		warn: "warn",

		pending: "pending",
		progress: "progress",

		success: "success",
		approved: "success",

		fail: "rejected",
		error: "rejected",
		rejected: "rejected",

		unapproved: "unapproved",
		notsubmitted: "notsubmitted"
	};

	const badgeType = mapStatusToStyle[item?.type] || "pending";

	return (
		<span className={`aui-lozenge res-${badgeType}-tag`}>
			{item?.title}
		</span>
	);
};

export { Badge };